import { useQuoteContext } from '../QuoteComponent.context'

const QuoteHighlightedText: React.FC = () => {
  const { highlightedText, presentationMode } = useQuoteContext()
  if (!highlightedText || presentationMode) {
    return null
  }
  return (
    <div className="absolute left-[-3px] top-[-3px] rounded-br-sm rounded-tl-xl bg-gray-600">
      <div className=" px-4 py-1 text-xs text-white">
        { highlightedText }
      </div>
    </div>
  )
}

export default QuoteHighlightedText
